import React from 'react'
import {component_tool, framework_tool} from "@/tool";

const {modelUtils} = framework_tool;
const {WizBrowserExport, WizButton, WizModal} = component_tool

export const mapStateToProps = ({nameSpace, method}, state, ownProps) => {
  const list = modelUtils.getModelEntity(state[nameSpace], `${nameSpace}@${method}`);
  const headList = list.data && list.data.headList
  return {
    dynamicColumns: Array.isArray(headList) && headList.length ? headList : []
  }
};

let formatTime = (time) => {
  // 转换为时分秒
  let h = parseInt(time / 60 / 60 % 24)
  let m = parseInt(time / 60 % 60)
  let s = parseInt(time % 60)
   let res = ''
   if (h > 0) {res += `${h}时`};
   if (m > 0) {res += `${m}分`};
   if (s > 0) {res += `${s}秒`};
  return res
}

export const handleExport = ({title, column, columnsType}, nextProps, nextState, key) => {
  let result = false;
  if (columnsType && columnsType) {
    result = true;
  }
  const res = nextProps[key];
  const {success, data = {}, msg} = res
  const {dataList = [], headList = []} = data
  if (success) {
    const rows = dataList.map(val => {
      for (const item in val) {
        if (item.includes('Rate')) {
          if (val[item] != null && val[item] != '/') {
            val[item] = item.includes('Rate') ? val[item] + '%' : val[item]
          }
        }
        if (item.includes('accountState') && val[item] !== undefined && val[item] !== null) {
          val[item] = val[item] == 1 ? '激活' : '禁用'
        }
        if (item.includes('jobState') && val[item] !== undefined && val[item] !== null) {
          val[item] = val[item] == 1 ? '在职' : '离职'
        }
        if (item.includes('status') && val[item] !== undefined && val[item] !== null) {
          val[item] = val[item] == 1 ? '发布' : val[item] = val[item] == 2 ? '关闭' : '草稿'
        }
        if (item.includes('duration') && val[item] !== undefined && val[item] !== null) {
          val[item] = formatTime(val[item])
        }
        if (item.includes('_result') && (val[item] === undefined || val[item] === null || val[item] === '')) {
          val[item] = '/'
        }
        if (item.includes('_pass') && (val[item] === undefined || val[item] === null || val[item] === '')) {
          val[item] = '/'
        }
      }
      return val
    })
    let headList_ = [];
    if (headList && headList.length) {
      headList.forEach(val => {
        const {name, list} = val;
        if (list && list.length) {
          let list_new = [];
          list.forEach(val_ => {
            if (val_) {
              if (!result || (result && val_ && val_.name && (val_.name === '完成状态' || val_.name === '完成时间' || val_.name === '通过人数' || val_.name === '阶段完成率'))) {
                list_new.push(val_);
              }
            }
            val.list = list_new;
          })
        }
        headList_.push(val);
      })
    }
    const _columns = headList_.map(val => ({
      headerName: val.name,
      field: val.key,
      children: val.list && val.list.length ? val.list.map(val => ({
        headerName: val.name,
        field: val.key
      })) : undefined
    }))

    WizBrowserExport({
      title,
      sheetName: title,
      columns: column.filter((_, index) => index).concat(_columns),
      rows,
      filename: title + '.xlsx',
    })
    return true
  } else {
    wizNotice.error(msg)
    return false;
  }
}

export function mergeColumns(columns, events, columnsType) {
  const {dynamicColumns} = this.props
  let result = false;
  if (columnsType && columnsType) {
    result = true;
  }
  let dynamicColumns_new = [];
  if (dynamicColumns && dynamicColumns.length) {
    dynamicColumns.forEach(val => {
      const {name, list} = val;
      if (list && list.length) {
        let list_new = [];
        list.forEach(val_ => {
          if (val_) {
            if (!result || (result && val_ && val_.name && (val_.name === '完成状态' || val_.name === '完成时间' || val_.name === '通过人数' || val_.name === '阶段完成率'))) {
              list_new.push(val_);
            }
          }
          val.list = list_new;
        })
      }
      dynamicColumns_new.push(val);
    })
  }
  const _dynamicColumns = dynamicColumns_new.map(val => ({
    title: val.name,
    name: val.key,
    tableItem: {
      children: val.list && val.list.length ? val.list.map(val => ({
          ...val,
          children: val.list && val.list.length ? val.list.map(val => ({
            ...val,
            dataIndex: val.key,
            title: val.name,
            render: text => {
              const item = val.key && val.key;
              if (typeof item === 'string' && (item.includes('accomplishType', item.length - 14))) {
                if (!text || text === undefined || text === '') {
                  return null;
                }
                if (events && events.length) {
                  for (let i = 0; i < events.length; i++) {
                    if (events[i].dataIndex === 'accomplishType') {
                      return <a onClick={() => events[i].event(text)}>{events[i].text}</a>
                    }
                  }
                }
              }
              if (text === undefined) {
                if (typeof item === 'string' && (item.includes('_result', item.length - 7) || item.includes('_pass', item.length - 5))) {
                  return '/';
                }
                return null;
              }
              if (val.name.includes('率', val.name.length - 1) && text === '/') {
                return text;
              }
              return val.name.includes('率', val.name.length - 1) ? text + '%' : text
            }
          })) : undefined,
          dataIndex: val.key,
          title: val.name,
          render: text => {
            const item = val.key && val.key;
            if (typeof item === 'string' && (item.includes('accomplishType', item.length - 14))) {
              if (!text || text === undefined || text === '') {
                return null;
              }
              if (events && events.length) {
                for (let i = 0; i < events.length; i++) {
                  if (events[i].dataIndex === 'accomplishType') {
                    return <a onClick={() => events[i].event(text)}>{events[i].text}</a>
                  }
                }
              }
            }
            if (text === undefined) {
              if (typeof item === 'string' && (item.includes('_result', item.length - 7) || item.includes('_pass', item.length - 5))) {
                return '/';
              }
              return null;
            }
            if (val.name.includes('率', val.name.length - 1) && text === '/') {
              return text;
            }
            return val.name.includes('率', val.name.length - 1) ? text + '%' : text
          }
        })
      ) : undefined,
    }
  }))

  return columns.concat(_dynamicColumns)
}
